<sgt-multi-select
  [options]="options"
  [settings]="settings"
  [(ngModel)]="idsAreas"
  (ngModelChange)="onSelectionChange()"
  (isFirstOpened)="firstOpened($event)"
  (search)="onSearch()">
</sgt-multi-select>
